export function makeTextBold(textarea: HTMLTextAreaElement): string | string[] | number
{
    if (textarea != null)
        return makeEmphasis(textarea, "**");
}

export function makeTextItalic(textarea: HTMLTextAreaElement): string | string[] | number
{
    if (textarea != null)
        return makeEmphasis(textarea, "_");
}

export function makeTextStrikethrough(textarea: HTMLTextAreaElement): string | string[] | number
{
    if (textarea != null)
        return makeEmphasis(textarea, "~~");
}

export function makeTextCode(textarea: HTMLTextAreaElement): string | string[] | number
{
    if (textarea != null)
        return makeEmphasis(textarea, "`");
}

export function makeUrl(textarea: HTMLTextAreaElement): string | string[] | number
{
    if (textarea != null)
        return makeEmphasis(textarea, "[", "]", "(url)");
    
    //var textarea: JQuery = $("#comment_textarea");
    //var newValue: string = textarea.val();
    //var match: RegExpMatchArray = newValue.match(/(\(url\))/g);

    //if (match && match.length === 1)
    //{
    //    var index: number = newValue.indexOf(match[0]);
    //    Utils.setCaretToPosition(textarea[0], index + 1, index + 4);
    //}
}

export function makeQuoteBlock(textarea: HTMLTextAreaElement): string | string[] | number
{
    if (textarea != null)
        return makeQuoteBlockOrList(textarea, ">");
}

export function makeBulletedList(textarea: HTMLTextAreaElement): string | string[] | number
{
    if (textarea != null)
        return makeQuoteBlockOrList(textarea, "-");
}

export function makeNumberedList(textarea: HTMLTextAreaElement): string | string[] | number
{
    if (textarea != null)
        return makeQuoteBlockOrList(textarea, 1);
}

export function makeQuoteBlockOrList(inpurt: HTMLTextAreaElement, symbol: any): string | string[] | number
{
    var textarea: JQuery = $(inpurt);
    var selectedText: string = getSelectionText();
    var currentCursorPosition = getCurrentCursorPosition(textarea[0]);
    var wordAtCaretPosition;
    var isNumberedList: boolean = false;

    if (parseInt(symbol) > 0)
        isNumberedList = true;

    if (!selectedText)
    {
        wordAtCaretPosition = getWordAt(textarea.val().toString(), currentCursorPosition);
        selectedText = wordAtCaretPosition.word;
    }

    if (selectedText)
    {
        var startPos: number = 0;
        var endPos: number = 0;
        var leftChars: string = "";
        var rightChars: string = "";

        if (wordAtCaretPosition && wordAtCaretPosition.word)
        {
            startPos = wordAtCaretPosition.startPosition;
            endPos = wordAtCaretPosition.endPosition;
            leftChars = textarea.val().toString().getLeftChars(startPos);
            rightChars = textarea.val().toString().getRightChars(endPos);
        }
        else
        {
            var input: any = textarea[0];
            startPos = input.selectionStart;
            endPos = input.selectionEnd;
            leftChars = textarea.val().toString().getLeftChars(startPos);
            rightChars = textarea.val().toString().getRightChars(endPos);
        }

        var selectedTextPieces: string[] = selectedText.split("\n");
        for (var i = 0; i < selectedTextPieces.length; i++)
        {
            if (isNumberedList)
            {
                if (i === 0)
                    selectedText = i + 1 + ". " + selectedTextPieces[i] + ((selectedTextPieces.length - 1 === i) ? "" : "\n");
                else
                    selectedText += i + 1 + ". " + selectedTextPieces[i] + ((selectedTextPieces.length - 1 === i) ? "" : "\n");
            }
            else
            {
                if (i === 0)
                    selectedText = symbol + " " + selectedTextPieces[i] + ((selectedTextPieces.length - 1 === i) ? "" : "\n");
                else
                    selectedText += symbol + " " + selectedTextPieces[i] + ((selectedTextPieces.length - 1 === i) ? "" : "\n");
            }
        }

        if (leftChars.trim() !== "" && rightChars.trim() !== "")
        {
            insertAtCursor(textarea[0], "\n\n" + selectedText + "\n\n", startPos, endPos);
        }
        else if (leftChars.trim() !== "")
        {
            insertAtCursor(textarea[0], "\n\n" + selectedText, startPos, endPos);
        }
        else if (rightChars.trim() !== "")
        {
            insertAtCursor(textarea[0], selectedText + "\n\n", startPos, endPos);
        }
        else
        {
            insertAtCursor(textarea[0], selectedText, startPos, endPos);
        }
    }
    else
    {
        insertAtCursor(textarea[0], "> ");

        // Neue Cursor Position setzen.
        currentCursorPosition = currentCursorPosition + 2;
        textarea.setCaretToPosition(currentCursorPosition, currentCursorPosition)
    }

    textarea.focus();
    return textarea.val();
}

export function makeEmphasis(input: HTMLTextAreaElement, emphasis: string, emphasisEnd?: string, concatString: string = ""): string | string[] | number
{
    var textarea: JQuery = $(input);
    var selectedText: string = getSelectionText();
    var currentCursorPosition = getCurrentCursorPosition(textarea[0]);
    var wordAtCaretPosition = null;

    if (!selectedText)
    {
        wordAtCaretPosition = getWordAt(textarea.val() as string, currentCursorPosition);
        selectedText = wordAtCaretPosition.word;
    }

    if (selectedText)
    {
        // Anzahl der selektierten whitespaces ermitteln.
        var leftWhitespaceCount: number = (selectedText.match(/^\s+/)) ? selectedText.match(/^\s+/)[0].length : 0;
        var rightWhitespaceCount: number = (selectedText.match(/\s+$/)) ? selectedText.match(/\s+$/)[0].length : 0;

        // Whitespaces entfernen.
        selectedText = selectedText.trim();
        var value: string = Array(leftWhitespaceCount + 1).join(" ") + emphasis + selectedText + emphasis + concatString + Array(rightWhitespaceCount + 1).join(" ");
        var valueWithEmphasisEnd: string = Array(leftWhitespaceCount + 1).join(" ") + emphasis + selectedText + emphasisEnd + concatString + Array(rightWhitespaceCount + 1).join(" ");

        // Markdown setzen.
        if (wordAtCaretPosition && wordAtCaretPosition.word)
        {
            if (emphasisEnd)
            {
                insertAtCursor(textarea[0], valueWithEmphasisEnd, wordAtCaretPosition.startPosition, wordAtCaretPosition.endPosition);
                textarea.setCaretToPosition(wordAtCaretPosition.startPosition + emphasis.length, wordAtCaretPosition.endPosition + emphasisEnd.length);
            }
            else
            {
                insertAtCursor(textarea[0], value, wordAtCaretPosition.startPosition, wordAtCaretPosition.endPosition);
                textarea.setCaretToPosition(wordAtCaretPosition.startPosition + emphasis.length, wordAtCaretPosition.endPosition + emphasis.length);
            }
        }
        else
        {
            if (emphasisEnd)
                insertAtCursor(textarea[0], valueWithEmphasisEnd);
            else
                insertAtCursor(textarea[0], value);

            // Neue Cursor Position setzen.
            currentCursorPosition = currentCursorPosition + emphasis.length;
            textarea.setCaretToPosition(currentCursorPosition, currentCursorPosition + selectedText.length);
        }
    }
    else
    {
        if (emphasisEnd)
            insertAtCursor(textarea[0], emphasis + emphasisEnd + concatString);
        else
            insertAtCursor(textarea[0], emphasis + emphasis + concatString);

        // Neue Cursor Position setzen.
        currentCursorPosition = currentCursorPosition + emphasis.length;
        textarea.setCaretToPosition(currentCursorPosition, currentCursorPosition)
    }

    textarea.focus();
    return textarea.val();
}

function getSelectionText()
{
    return window.getSelection().toString();
}

function getCurrentCursorPosition(input): number
{
    return input.selectionStart;
}

function insertAtCursor(input: any, value: string, start?: number, end?: number)
{
    ////IE support
    //if (document.selection)
    //{
    //    myField.focus();
    //    sel = document.selection.createRange();
    //    sel.text = myValue;
    //}
    //MOZILLA and others

    var startPos: number = -1;
    var endPos: number = 0;
    if (start >= 0 && end >= 0)
    {
        startPos = start;
        endPos = end;
    }
    else
    {
        if (input.selectionStart || input.selectionStart == '0')
        {
            startPos = input.selectionStart;
            endPos = input.selectionEnd;
        }
    }

    if (startPos >= 0)
    {
        input.value = input.value.substring(0, startPos) + value + input.value.substring(endPos, input.value.length);
    }
    else
    {
        input.value += value;
    }
}

function getWordAt(str: string, position: number): { word: string, startPosition: number, endPosition: number }
{
    // Wort ermitteln was links vom Caret ist.
    var left: number = str.slice(0, position).search(/\S+$/);

    // Wort ermitteln was rechts vom Caret ist.
    var right: number = str.slice(position).search(/\s/);
    if (right < 0)
    {
        right = str.slice(position).search(/\w$/);
        if (right > 0) right++;
    }

    // Wenn links und rechts was gefunden wurde, heißt das, dass das Caret
    // direkt innerhalb einem Wort positioniert ist. Andernfalls ist entweder links oder
    // rechts direkt ein Wort oder nichts.
    if (left >= 0 && right >= 0)
    {
        return {
            word: str.slice(left, right + position),
            startPosition: left,
            endPosition: right + position
        };
    }
    else if (left >= 0)
    {
        return {
            word: str.slice(left, position),
            startPosition: left,
            endPosition: position
        };
    }
    else if (right >= 0)
    {
        return {
            word: str.slice(position, right + position),
            startPosition: position,
            endPosition: right + position
        };
    }
    else
    {
        return {
            word: null,
            startPosition: -1,
            endPosition: -1
        };
    }
}